module.exports = __webpack_public_path__ + "static/lorem-ipsum-book-cover-front-ed5c87fd8b0ceb8cb0be81c16415d750.jpg";